import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { IoArrowBack } from 'react-icons/io5';
import './Legal.css';

const Privacy = () => {
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  const isEn = lang === 'en';
  const isVi = lang === 'vi';
  const isZh = lang === 'zh';
  const isFr = lang === 'fr';

  return (
    <div className="legal-page">
      <div className="legal-container">
        <Link to="/" className="legal-back">
          <IoArrowBack />
          <span>{t('common.home') || 'Home'}</span>
        </Link>

        <h1>{t('footer.privacy')}</h1>

        <div className="legal-content">
          {isEn && (
            <>
              <section>
                <h2>1. {t('legal.intro') || 'Introduction'}</h2>
                <p>emoozi ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our private social network platform.</p>
              </section>

              <section>
                <h2>2. {t('legal.privacyLegalBasis') || 'Legal Basis'}</h2>
                <p>This Privacy Policy is prepared in compliance with Vietnam Cybersecurity Law No. 24/2018/QH14, Law on Information Security No. 86/2015/QH13, and Decree No. 13/2023/NĐ-CP on Personal Data Protection.</p>
              </section>

              <section>
                <h2>3. {t('legal.infoCollect') || 'Information We Collect'}</h2>
                <p><strong>3.1 Personal Information You Provide:</strong> Account information (username, email, phone, display name), Profile information (avatar, bio), Content you post (text, images, videos, voice messages), Messages you send to other users, Friend connections and interactions.<br/><br/>
                <strong>3.2 Automatically Collected Information:</strong> Device information (device type, operating system), Usage data (features used, time spent), IP address and access times.</p>
              </section>

              <section>
                <h2>4. {t('legal.infoUse') || 'How We Use Your Information'}</h2>
                <p>We use your information to: (a) Provide and maintain our Service; (b) Process your registration and account management; (c) Enable social features (messaging, sharing, friending); (d) Improve and personalize your experience; (e) Communicate with you about updates and support; (f) Comply with legal obligations.</p>
              </section>

              <section>
                <h2>5. {t('legal.dataPrinciples') || 'Data Protection Principles'}</h2>
                <p>We adhere to the following principles: (a) Lawfulness, fairness, and transparency; (b) Purpose limitation; (c) Data minimization; (d) Accuracy; (e) Storage limitation; (f) Integrity and confidentiality.</p>
              </section>

              <section>
                <h2>6. {t('legal.dataSharing') || 'Data Sharing and Disclosure'}</h2>
                <p>6.1. We do NOT sell your personal data to third parties.<br/>
                6.2. We may share data with: Service providers who assist in operating our platform; Legal authorities when required by Vietnamese law; Users you choose to interact with (within the platform).<br/>
                6.3. Any data sharing complies with Vietnamese law and is limited to what is necessary.</p>
              </section>

              <section>
                <h2>7. {t('legal.dataStorage') || 'Data Storage and Security'}</h2>
                <p>7.1. Your data is stored on servers located in Vietnam.<br/>
                7.2. We implement appropriate technical and organizational measures: Encryption of data in transit and at rest; Access controls and authentication; Regular security assessments; Employee confidentiality obligations.</p>
              </section>

              <section>
                <h2>8. {t('legal.yourRights') || 'Your Rights'}</h2>
                <p>Under Vietnamese law, you have the right to: (a) Access your personal data; (b) Correct inaccurate personal data; (c) Request deletion of your personal data; (d) Object to processing of your data; (e) Data portability; (f) Withdraw consent.<br/>
                To exercise these rights, please contact us at: qa@emoozi.com</p>
              </section>

              <section>
                <h2>9. {t('legal.dataRetention') || 'Data Retention'}</h2>
                <p>9.1. We retain your personal data for as long as your account is active.<br/>
                9.2. After account deletion: Data is deleted within 30 days; Some data may be retained as required by law.</p>
              </section>

              <section>
                <h2>10. {t('legal.childrenPrivacy') || "Children's Privacy"}</h2>
                <p>10.1. Our Service is not intended for children under 13.<br/>
                10.2. We do not knowingly collect data from children under 13.<br/>
                10.3. If we discover such data, it will be promptly deleted.</p>
              </section>

              <section>
                <h2>11. {t('legal.policyChanges') || 'Changes to This Policy'}</h2>
                <p>We may update this Privacy Policy to reflect changes in our practices or Vietnamese law. We will notify you of any material changes.</p>
              </section>

              <section>
                <h2>12. {t('legal.contactInfo') || 'Contact Information'}</h2>
                <p>If you have questions about this Privacy Policy, please contact us at: qa@emoozi.com</p>
              </section>
            </>
          )}

          {isVi && (
            <>
              <section>
                <h2>1. {t('legal.intro') || 'Giới Thiệu'}</h2>
                <p>emoozi ("chúng tôi") cam kết bảo vệ quyền riêng tư của bạn. Chính Sách Quyền Riêng Tư này giải thích cách chúng tôi thu thập, sử dụng, tiết lộ và bảo vệ thông tin của bạn khi sử dụng nền tảng mạng xã hội riêng tư của chúng tôi.</p>
              </section>

              <section>
                <h2>2. {t('legal.privacyLegalBasis') || 'Cơ Sở Pháp Lý'}</h2>
                <p>Chính Sách này được xây dựng tuân thủ Luật An Ninh Mạng số 24/2018/QH14, Luật An Toàn Thông Tin Mạng số 86/2015/QH13, và Nghị định số 13/2023/NĐ-CP về Bảo Vệ Dữ Liệu Cá Nhân.</p>
              </section>

              <section>
                <h2>3. {t('legal.infoCollect') || 'Thông Tin Chúng Tôi Thu Thập'}</h2>
                <p><strong>3.1 Thông Tin Bạn Cung Cấp:</strong> Thông tin tài khoản (tên đăng nhập, email, điện thoại, tên hiển thị), Thông tin hồ sơ (ảnh đại diện, tiểu sử), Nội dung bạn đăng (văn bản, hình ảnh, video, tin thoại), Tin nhắn bạn gửi, Kết nối bạn bè và tương tác.<br/><br/>
                <strong>3.2 Thông Tin Thu Thập Tự Động:</strong> Thông tin thiết bị (loại thiết bị, hệ điều hành), Dữ liệu sử dụng (tính năng sử dụng, thời gian truy cập), Địa chỉ IP và thời gian truy cập.</p>
              </section>

              <section>
                <h2>4. {t('legal.infoUse') || 'Cách Chúng Tôi Sử Dụng Thông Tin'}</h2>
                <p>Chúng tôi sử dụng thông tin của bạn để: (a) Cung cấp và duy trì Dịch vụ; (b) Xử lý đăng ký và quản lý tài khoản; (c) Bật tính năng xã hội (nhắn tin, chia sẻ, kết bạn); (d) Cải thiện và cá nhân hóa trải nghiệm; (e) Liên lạc với bạn; (f) Tuân thủ nghĩa vụ pháp luật.</p>
              </section>

              <section>
                <h2>5. {t('legal.dataPrinciples') || 'Nguyên Tắc Bảo Vệ Dữ Liệu'}</h2>
                <p>Chúng tôi tuân thủ các nguyên tắc sau: (a) Hợp pháp, công bằng và minh bạch; (b) Giới hạn mục đích; (c) Tối thiểu hóa dữ liệu; (d) Độ chính xác; (e) Giới hạn lưu trữ; (f) Tính toàn vẹn và bảo mật.</p>
              </section>

              <section>
                <h2>6. {t('legal.dataSharing') || 'Chia Sẻ và Tiết Lộ Dữ Liệu'}</h2>
                <p>6.1. Chúng tôi KHÔNG bán dữ liệu cá nhân của bạn cho bên thứ ba.<br/>
                6.2. Chúng tôi có thể chia sẻ dữ liệu với: Nhà cung cấp dịch vụ hỗ trợ vận hành nền tảng; Cơ quan pháp luật khi được pháp luật Việt Nam yêu cầu; Người dùng bạn chọn tương tác (trong nền tảng).<br/>
                6.3. Mọi chia sẻ dữ liệu tuân thủ pháp luật Việt Nam.</p>
              </section>

              <section>
                <h2>7. {t('legal.dataStorage') || 'Lưu Trữ và Bảo Mật Dữ Liệu'}</h2>
                <p>7.1. Dữ liệu của bạn được lưu trữ trên máy chủ tại Việt Nam.<br/>
                7.2. Chúng tôi thực hiện các biện pháp: Mã hóa dữ liệu; Kiểm soát truy cập; Đánh giá bảo mật định kỳ; Nghĩa vụ bảo mật của nhân viên.</p>
              </section>

              <section>
                <h2>8. {t('legal.yourRights') || 'Quyền Của Bạn'}</h2>
                <p>Theo pháp luật Việt Nam, bạn có quyền: (a) Truy cập dữ liệu cá nhân; (b) Sửa dữ liệu không chính xác; (c) Yêu cầu xóa dữ liệu; (d) Phản đối xử lý dữ liệu; (e) Chuyển giao dữ liệu; (f) Rút lại sự đồng ý.<br/>
                Để thực hiện các quyền này, vui lòng liên hệ: qa@emoozi.com</p>
              </section>

              <section>
                <h2>9. {t('legal.dataRetention') || 'Lưu Giữ Dữ Liệu'}</h2>
                <p>9.1. Chúng tôi lưu giữ dữ liệu cá nhân của bạn khi tài khoản còn hoạt động.<br/>
                9.2. Sau khi xóa tài khoản: Dữ liệu được xóa trong vòng 30 ngày; Một số dữ liệu có thể được lưu giữ theo yêu cầu của pháp luật.</p>
              </section>

              <section>
                <h2>10. {t('legal.childrenPrivacy') || 'Quyền Riêng Tư Trẻ Em'}</h2>
                <p>10.1. Dịch vụ của chúng tôi không dành cho trẻ em dưới 13 tuổi.<br/>
                10.2. Chúng tôi không cố tình thu thập dữ liệu từ trẻ em dưới 13 tuổi.<br/>
                10.3. Nếu phát hiện dữ liệu như vậy, chúng tôi sẽ xóa ngay lập tức.</p>
              </section>

              <section>
                <h2>11. {t('legal.policyChanges') || 'Thay Đổi Chính Sách'}</h2>
                <p>Chúng tôi có thể cập nhật Chính Sách Quyền Riêng Tư này để phản ánh thay đổi. Chúng tôi sẽ thông báo cho bạn về bất kỳ thay đổi quan trọng nào.</p>
              </section>

              <section>
                <h2>12. {t('legal.contactInfo') || 'Thông Tin Liên Hệ'}</h2>
                <p>Nếu bạn có câu hỏi về Chính Sách Quyền Riêng Tư này, vui lòng liên hệ: qa@emoozi.com</p>
              </section>
            </>
          )}

          {isZh && (
            <>
              <section>
                <h2>1. {t('legal.intro') || '介绍'}</h2>
                <p>emoozi（"我们"）致力于保护您的隐私。本隐私政策说明我们如何收集、使用、披露和保护您使用我们的私人社交网络平台时的信息。</p>
              </section>

              <section>
                <h2>2. {t('legal.privacyLegalBasis') || '法律依据'}</h2>
                <p>本隐私政策根据越南网络安全法第24/2018/QH14号、2015年第86/2015/QH13号信息安全法以及2023年第13/NĐ-CP号个人数据保护 decree制定。</p>
              </section>

              <section>
                <h2>3. {t('legal.infoCollect') || '我们收集的信息'}</h2>
                <p><strong>3.1 您提供的个人信息：</strong>账户信息（用户名、邮箱、电话、显示名称）、个人资料信息（头像、简介）、您发布的内容（文字、图片、视频、语音消息）、您发送给其他用户的消息、好友连接和互动。<br/><br/>
                <strong>3.2 自动收集的信息：</strong>设备信息（设备类型、操作系统）、使用数据（使用的功能、花费的时间）、IP地址和访问时间。</p>
              </section>

              <section>
                <h2>4. {t('legal.infoUse') || '我们如何使用您的信息'}</h2>
                <p>我们使用您的信息来：(a) 提供和维护我们的服务；(b) 处理您的注册和账户管理；(c) 启用社交功能（消息、分享、添加好友）；(d) 改善和个性化您的体验；(e) 与您沟通更新和支持；(f) 遵守法律义务。</p>
              </section>

              <section>
                <h2>5. {t('legal.dataPrinciples') || '数据保护原则'}</h2>
                <p>我们遵循以下原则：(a) 合法性、公平性和透明度；(b) 目的限制；(c) 数据最小化；(d) 准确性；(e) 存储限制；(f) 完整性和保密性。</p>
              </section>

              <section>
                <h2>6. {t('legal.dataSharing') || '数据共享和披露'}</h2>
                <p>6.1. 我们不会将您的个人数据出售给第三方。<br/>
                6.2. 我们可能与以下方共享数据：帮助我们运营平台的 service providers；根据越南法律要求时的法律当局；您选择与之互动的用户（在平台内）。<br/>
                6.3. 任何数据共享均符合越南法律且仅限于必要范围。</p>
              </section>

              <section>
                <h2>7. {t('legal.dataStorage') || '数据存储和安全'}</h2>
                <p>7.1. 您的数据存储在位于越南的服务器上。<br/>
                7.2. 我们实施适当的技术和组织措施：传输和存储时的数据加密；访问控制和身份验证；定期安全评估；员工保密义务。</p>
              </section>

              <section>
                <h2>8. {t('legal.yourRights') || '您的权利'}</h2>
                <p>根据越南法律，您有权：(a) 访问您的个人数据；(b) 更正不准确的个人数据；(c) 要求删除您的个人数据；(d) 反对处理您的数据；(e) 数据可携性；(f) 撤回同意。<br/>
                要行使这些权利，请联系我们：qa@emoozi.com</p>
              </section>

              <section>
                <h2>9. {t('legal.dataRetention') || '数据保留'}</h2>
                <p>9.1. 我们会在您的账户活跃期间保留您的个人数据。<br/>
                9.2. 账户删除后：数据将在30天内删除；某些数据可能会根据法律要求保留。</p>
              </section>

              <section>
                <h2>10. {t('legal.childrenPrivacy') || '儿童隐私'}</h2>
                <p>10.1. 我们的服务不面向13岁以下的儿童。<br/>
                10.2. 我们不会故意收集13岁以下儿童的数据。<br/>
                10.3. 如果发现此类数据，将立即删除。</p>
              </section>

              <section>
                <h2>11. {t('legal.policyChanges') || '本政策变更'}</h2>
                <p>我们可能会更新本隐私政策以反映我们实践或越南法律的变化。我们将通知您任何重大变更。</p>
              </section>

              <section>
                <h2>12. {t('legal.contactInfo') || '联系信息'}</h2>
                <p>如果您对本隐私政策有疑问，请联系我们：qa@emoozi.com</p>
              </section>
            </>
          )}

          {isFr && (
            <>
              <section>
                <h2>1. {t('legal.intro') || 'Introduction'}</h2>
                <p>emoozi ("nous") s'engage à protéger votre vie privée. Cette Politique de confidentialité explique comment nous collectons, utilisons, divulguons et protégeons vos informations lorsque vous utilisez notre plateforme de réseau social privé.</p>
              </section>

              <section>
                <h2>2. {t('legal.privacyLegalBasis') || 'Base légale'}</h2>
                <p>Cette Politique de confidentialité est élaborée conformément à la Loi vietnamienne sur la cybersécurité n° 24/2018/QH14, à la Loi sur la sécurité de l'information n° 86/2015/QH13, et au Décret n° 13/2023/NĐ-CP sur la protection des données personnelles.</p>
              </section>

              <section>
                <h2>3. {t('legal.infoCollect') || 'Informations que nous collectons'}</h2>
                <p><strong>3.1 Informations personnelles que vous fournissez :</strong> Informations de compte (nom d'utilisateur, e-mail, téléphone, nom d'affichage), Informations de profil (avatar, bio), Contenu que vous publiez (texte, images, vidéos, messages vocaux), Messages que vous envoyez aux autres utilisateurs, Connexions et interactions amicales.<br/><br/>
                <strong>3.2 Informations collectées automatiquement :</strong> Informations sur l'appareil (type d'appareil, système d'exploitation), Données d'utilisation (fonctionnalités utilisées, temps passé), Adresse IP et heures d'accès.</p>
              </section>

              <section>
                <h2>4. {t('legal.infoUse') || 'Comment nous utilisons vos informations'}</h2>
                <p>Nous utilisons vos informations pour : (a) Fournir et maintenir notre Service ; (b) Traiter votre inscription et la gestion de votre compte ; (c) Activer les fonctionnalités sociales (messagerie, partage, amitié) ; (d) Améliorer et personnaliser votre expérience ; (e) Communiquer avec vous sur les mises à jour et le support ; (f) Respecter les obligations légales.</p>
              </section>

              <section>
                <h2>5. {t('legal.dataPrinciples') || 'Principes de protection des données'}</h2>
                <p>Nous adhérerons aux principes suivants : (a) Licéité, équité et transparence ; (b) Limitation de la finalité ; (c) Minimisation des données ; (d) Exactitude ; (e) Limitation de la conservation ; (f) Intégrité et confidentialité.</p>
              </section>

              <section>
                <h2>6. {t('legal.dataSharing') || 'Partage et divulgation des données'}</h2>
                <p>6.1. Nous ne vendons PAS vos données personnelles à des tiers.<br/>
                6.2. Nous pouvons partager des données avec : Les fournisseurs de services qui nous aident à exploiter notre plateforme ; Les autorités légales lorsque la loi vietnamienne l'exige ; Les utilisateurs avec lesquels vous choisissez d'interagir (sur la plateforme).<br/>
                6.3. Tout partage de données est conforme à la loi vietnamienne et limité au nécessaire.</p>
              </section>

              <section>
                <h2>7. {t('legal.dataStorage') || 'Stockage et sécurité des données'}</h2>
                <p>7.1. Vos données sont stockées sur des serveurs situés au Vietnam.<br/>
                7.2. Nous mettons en œuvre des mesures techniques et organisationnelles appropriées : Chiffrement des données en transit et au repos ; Contrôles d'accès et authentification ; Évaluations de sécurité régulières ; Obligations de confidentialité des employés.</p>
              </section>

              <section>
                <h2>8. {t('legal.yourRights') || 'Vos droits'}</h2>
                <p>Selon la loi vietnamienne, vous avez le droit de : (a) Accéder à vos données personnelles ; (b) Corriger les données personnelles inexactes ; (c) Demander la suppression de vos données personnelles ; (d) Vous opposer au traitement de vos données ; (e) Portabilité des données ; (f) Retirer votre consentement.<br/>
                Pour exercer ces droits, veuillez nous contacter à : qa@emoozi.com</p>
              </section>

              <section>
                <h2>9. {t('legal.dataRetention') || 'Conservation des données'}</h2>
                <p>9.1. Nous conservons vos données personnelles tant que votre compte est actif.<br/>
                9.2. Après suppression du compte : Les données sont supprimées dans les 30 jours ; Certaines données peuvent être conservées comme requis par la loi.</p>
              </section>

              <section>
                <h2>10. {t('legal.childrenPrivacy') || 'Confidentialité des enfants'}</h2>
                <p>10.1. Notre Service n'est pas destiné aux enfants de moins de 13 ans.<br/>
                10.2. Nous ne collectons pas sciemment de données auprès d'enfants de moins de 13 ans.<br/>
                10.3. Si nous découvrons de telles données, elles seront immédiatement supprimées.</p>
              </section>

              <section>
                <h2>11. {t('legal.policyChanges') || 'Modifications de cette politique'}</h2>
                <p>Nous pouvons mettre à jour cette Politique de confidentialité pour refléter les changements de nos pratiques ou de la loi vietnamienne. Nous vous notifierons tout changement important.</p>
              </section>

              <section>
                <h2>12. {t('legal.contactInfo') || 'Coordonnées'}</h2>
                <p>Si vous avez des questions sur cette Politique de confidentialité, veuillez nous contacter à : qa@emoozi.com</p>
              </section>
            </>
          )}

          <p className="legal-updated">
            {t('legal.lastUpdated') || 'Last updated'}: March 4, 2026
          </p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
